import React from 'react';
import { createUniqueKey } from '../../../utils';
import { Column } from '../utils/types';

interface IScrollableColumns {
    mini: boolean,
    scrollable: boolean,
    columns: Column[];
};

function ScrollableColumns({
    scrollable, columns = [], mini,
}: IScrollableColumns) {
    if (!scrollable && !mini) return null;

    return (
        <colgroup>
            {columns.map(({ width, minWidth }, index) => (
                <col
                    key={createUniqueKey(index, width)}
                    style={{ width, minWidth: minWidth || width }}
                />
            ))}
        </colgroup>
    );
}

export default ScrollableColumns;
